import { MobileScaleRangeSlider } from './scaleRangeSlider/MobileScaleRangeSlider';
import ScaleRangeSlider from './scaleRangeSlider/ScaleRangeSlider';
import Size from './Size';

export function ImageNavigationToolbar() {
  return (
    <>
      <div className="hidden md:block" style={{ gridArea: 'left' }}>
        <Size />
      </div>
      <div className="md:hidden" style={{ gridArea: 'left' }}>
        <MobileScaleRangeSlider />
      </div>
      <div className="hidden md:flex" style={{ gridArea: 'center' }}>
        <ScaleRangeSlider />
      </div>
    </>
  );
}
